import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import {
  ExamTimer,
  QuestionsMap,
  Question,
  Modal,
  Spinner,
} from "../../components"
import {
  startTimer,
  setAnswer,
  markAsViewed,
  registerExam,
  getCities,
  getCourses,
} from "./examActions"

import ExamUserInterestsModal from "./ExamUserInterestsModal"

class ExamPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      timerIsCounting: false,
      answer: null,
      finishModalIsVisible: false,
      finishFormIsVisible: false,
      cidade: null,
      curso: "",
      confirmModal: false,
      telefone: null,
      aceitouTermos: false,
      concluiuEnsinoMedio: null,
      currentSituation: null,
      interesseEmBolsa: null,
    }
  }

  componentDidMount() {
    if (!this.props.timerStartDate) {
      this.props.startTimer()
    }

    const { id } = this.props.match.params;

    this.setState({ timerIsCounting: true })

    if (id && this.props.exam && this.props.exam.questoes) {
      let activeQuestion = this.props.exam.questoes[Number(id) - 1]
      this.setState({ answer: activeQuestion.resposta })

      if (!this.props.exam.questoes[Number(id) - 1].vista) {
        this.props.markAsViewed(id)
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { id } = this.props.match.params

    if (prevProps.match.params.id !== id) {
      let activeQuestion = this.props.exam.questoes[Number(id) - 1]

      if (this.props.exam && !activeQuestion.vista) {
        this.props.markAsViewed(id)
      }

      this.setState({ answer: activeQuestion.resposta })
    }

    if (!this.props.user) {
      this.props.history.push("/")
    }
  }

  handleInputChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  closeModal() {
    this.setState({ finishModalIsVisible: false, finishFormIsVisible: false })
  }

  closeFinishModal() {
    this.setState({ finishModalIsVisible: false, finishFormIsVisible: false })
    this.props.history.push("/")
  }

  goToQuestion(number) {
    const { id } = this.props.match.params
    const { answer } = this.state

    if (answer) {
      this.props.setAnswer(id, answer)
    }

    this.setState({ answer: null })
    this.props.history.push(`/questao/${number}`)
  }

  prevQuestion() {
    this.goToQuestion(Number(this.props.match.params.id) - 1)
  }

  jumpQuestion() {
    const { id } = this.props.match.params
    this.goToQuestion(Number(id) + 1)
  }

  nextQuestion() {
    const { id } = this.props.match.params
    const { answer } = this.state

    if (answer) {
      this.props.setAnswer(id, answer)
    }
    this.goToQuestion(Number(id) + 1)
  }

  finishOnLastQuestion() {
    const { id } = this.props.match.params
    const { answer } = this.state

    if (answer) {
      this.props.setAnswer(id, answer)
    }

    this.setState({ finishModalIsVisible: true })
  }

  showFinishForm = () => {
    //Se usuário não informou os dados de curso/cidade/etc no mes atual, entao pede novamente
    if (this.props.exam.lastUserInterestsInMonth.length === 0) {
      this.setState({ finishFormIsVisible: true })
    } else {
      this.setState({ finishModalIsVisible: false })
      // console.log('this.props.exam.lastUserInterestsInMonth', this.props.exam.lastUserInterestsInMonth)
      this.finishExam(null)
    }
  }

  showConfirmModal() {
    this.closeModal()
    this.setState({ confirmModal: true })
  }

  closeConfirmModal() {
    this.setState({ confirmModal: false })
    this.showFinishForm()
  }

  finishExam = (event) => {
    // event.preventDefault(); Esse event não é maus um evento de submit, ver component ExamUserInterestsForm, onSubmit prop

    if (
      this.props.exam.lastUserInterestsInMonth.length > 0 ||
      (this.state.cidade != null &&
        this.state.curso != null &&
        this.state.telefone != null &&
        this.state.aceitouTermos != null &&
        this.state.concluiuEnsinoMedio != null)
    ) {
      let curso = this.state.curso
      let cidade = this.state.cidade

      if (this.props.exam.lastUserInterestsInMonth.length > 0) {
        curso = this.props.exam.lastUserInterestsInMonth[0].curso
        cidade = this.props.exam.lastUserInterestsInMonth[0].cidade
      }
      let answers = {
        ...this.props.exam,
        questoes: [...this.props.exam.questoes].map((question) => {
          return {
            questao: question._id,
            resposta: question.resposta ? question.resposta : null,
          }
        }),
        cidade,
        curso,
        inicio: this.props.timerStartDate,
        termino: Date.now(),
        telefone: this.state.telefone,
        aceitouTermos: this.state.aceitouTermos,
        concluiuEnsinoMedio: this.state.concluiuEnsinoMedio,
        interesseEmBolsa: this.state.interesseEmBolsa,
        currentSituation: this.state.currentSituation,
        lastUserInterestsInMonth: this.props.exam.lastUserInterestsInMonth,
      }

      this.props.registerExam(this.props.exam, answers).then((res) => {
        if (event) {
          event.callback()
        }
        this.props.history.push("/resultado")
      })
    }
  }

  handleChange = (e) => {
    let { name, value } = e.target

    // console.log('name/value==>',name,value,e.target.type, e.target.checked)
    if (e.target.type === "checkbox") {
      value = e.target.checked
    }
    this.setState({
      [name]: value,
    })
  }

  render() {
    const questionNumber = this.props.match.params.id
    const { exam } = this.props
    const { telefone } = this.state
    return (
      <div className="wrapper">
        <div className="content">
          <h2 className="inverse text-center">Simulado do ENEM</h2>
          <div className="exam-container">
            <div className="grid-x grid-margin-x medium-spacing">
              <div className="small-12 large-8 cell">
                <QuestionsMap
                  questions={this.props.exam.questoes}
                  onQuestionSelected={(number) =>
                    this.goToQuestion(Number(number) + 1)
                  }
                />
              </div>
              <div className="small-12 large-4 cell timer">
                <ExamTimer
                  start={this.props.timerStartDate}
                  isCounting={this.state.timerIsCounting}
                />
                <div className="end-test-button-container">
                  <button
                    type="button"
                    className="primary light-blue-hover expanded button"
                    onClick={() =>
                      this.setState({ finishModalIsVisible: true })
                    }
                  >
                    CONCLUIR SIMULADO
                  </button>
                </div>
              </div>
            </div>
            <Question
              data={exam.questoes[Number(questionNumber) - 1]}
              number={questionNumber}
              onAnswered={(answer) => this.setState({ answer })}
              selectedAnswer={this.state.answer}
            />
            <div className="control-bar">
              <div className="grid-x align-center grid-margin-x">
                <div className="shrink cell">
                  <button
                    className="control light-blue-hover primary button"
                    onClick={() => this.prevQuestion()}
                    disabled={Number(questionNumber) < 2}
                  >
                    voltar
                  </button>
                </div>
                <div className="shrink text-center cell">
                  {Number(questionNumber) < exam.questoes.length && (
                    <button
                      className="control light-blue-hover primary button"
                      onClick={() => this.jumpQuestion()}
                    >
                      pular
                    </button>
                  )}
                </div>
                <div className="auto medium-shrink cell">
                  {Number(questionNumber) < exam.questoes.length ? (
                    <button
                      className="control light-blue-hover primary button"
                      onClick={() => this.nextQuestion()}
                    >
                      próxima
                    </button>
                  ) : (
                    <button
                      className="control light-blue-hover primary button"
                      onClick={() => this.finishOnLastQuestion()}
                    >
                      concluir simulado
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Modal
            isVisible={
              this.state.finishModalIsVisible && !this.state.finishFormIsVisible
            }
          >
            {exam.questoes &&
              exam.questoes.filter((question) => !question.resposta).length >
              0 ? (
              <div className="text-center">
                <h4 className="bold">
                  Deseja realmente finalizar seu simulado?
                </h4>
                <p className="modal-container__text">
                  Você não respondeu todas as questões
                </p>
              </div>
            ) : (
              <div className="text-center">
                <h4>Parabéns</h4>
                <p>Você respondeu todas as questões!</p>
                <i className="icon-parabens" />
                <h4 className="modal-container__text">
                  Deseja realmente finalizar seu Simulado?
                </h4>
              </div>
            )}
            <div className="modal-button-bar">
              <button
                type="button"
                className="success button"
                onClick={() => this.showFinishForm()}
              >
                Sim
              </button>
              <button
                type="button"
                className="alert button"
                onClick={() => this.closeModal()}
              >
                Não
              </button>
            </div>
          </Modal>
          <ExamUserInterestsModal
            isVisible={this.state.finishFormIsVisible}
            onSubmit={(e) => this.finishExam(e)}
            setTelefone={(value) => this.setState({ telefone: value })}
            setCurso={(value) => this.setState({ curso: value.value })}
            setCidade={(value) => this.setState({ cidade: value.value })}
            props={this.props}
            telefone={telefone}
            getCourses={this.props.getCourses}
            getCities={this.props.getCities}
            handleChange={this.handleChange}
          />
          {/* <Modal isVisible={this.state.confirmModal}>
                        <div className="text-center">
                            <h4>Deseja realmente iniciar outro simulado?</h4>
                            <p className="modal-container__text">O resultado deste exame será perdido</p>
                        </div>
                        <div className="modal-button-bar">
                            <button
                                type="button"
                                className="success button"
                                onClick={() => this.props.history.push('/monte-seu-simulado')}
                            >
                                Sim
                            </button>
                            <button
                                type="button"
                                className="alert button"
                                onClick={() => this.closeConfirmModal()}
                            >
                                Não
                            </button>
                        </div>
                    </Modal> */}
          <Spinner isLoading={this.props.loading} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.account.user,
  loading: state.exam.loading,
  exam: state.exam.exam,
  timerStartDate: state.exam.timerStartDate,
})

export default connect(mapStateToProps, {
  startTimer,
  setAnswer,
  markAsViewed,
  registerExam,
  getCities,
  getCourses,
})(ExamPage)
